angular.module('bmsApp.sm.quote')
	.controller('RugCleaningPhotosModalCtrl', function ($scope,
														 $modalInstance,
														 $q,
														SMRugCleaningPhotoSvc,
														 jobCleaningService,
														 visit) {


		function init() {

			var filters = {};
			if(jobCleaningService){
				filters.JobCleaningService = jobCleaningService.id;
			}
			if(visit){
				filters.Visit = visit.id;
			}
			var promises = {
				rugCleaningPhotos: SMRugCleaningPhotoSvc.index({'filter':angular.extend(filters,{'BeforePhotoOnly':true})}),
			};

			$q.all(promises).then(function(responses) {
				self.rugCleaningPhotos = responses.rugCleaningPhotos.data.rug_cleaning_photo_collection;
				self.loading = false;
			});


		}


		function close() {
			$modalInstance.dismiss('cancel');
		}

		var self = $scope.RugCleaningPhotosModalCtrl = {
			rugCleaningPhotos: {},
			loading: true,
			processing: false,
			options: {},
			methods: {
				init: init,
				close: close,
			}
		};


	});
